import React, { useState } from 'react';
import { Sparkles, ArrowRight, Instagram, Facebook, Mail, Check } from 'lucide-react';
import { toast } from 'sonner';
import Logo from './Logo';

const SocialButton = ({ children, label }) => (
  <a
    href="#"
    aria-label={label}
    className="h-10 w-10 rounded-full border border-white/12 flex items-center justify-center text-white/70 hover:text-white hover:border-[var(--crea-red)] transition-colors"
  >
    {children}
  </a>
);

export default function ComingSoon() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error('Vul een geldig e-mailadres in.');
      return;
    }
    const list = JSON.parse(localStorage.getItem('crealabs_notify') || '[]');
    if (!list.includes(email)) list.push(email);
    localStorage.setItem('crealabs_notify', JSON.stringify(list));
    setDone(true);
    setEmail('');
    toast.success('Gelukt! We houden je op de hoogte van de lancering.');
  };

  return (
    <div className="relative min-h-screen bg-[#0c0c0e] overflow-hidden flex flex-col">
      {/* Background layers */}
      <div className="absolute inset-0 dot-grid-dark opacity-80" />
      <div className="pointer-events-none absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full hero-glow glow-pulse" />
      <div className="pointer-events-none absolute -bottom-52 -left-40 w-[520px] h-[520px] rounded-full bg-[radial-gradient(closest-side,rgba(224,18,48,0.12),transparent)]" />
      {/* decorative rotating ring */}
      <div className="pointer-events-none absolute top-1/2 right-[-220px] -translate-y-1/2 w-[520px] h-[520px] rounded-full border border-white/[0.05] spin-ring hidden lg:block" />
      <div className="pointer-events-none absolute top-1/2 right-[-160px] -translate-y-1/2 w-[380px] h-[380px] rounded-full border border-white/[0.06] hidden lg:block" />

      {/* Top bar */}
      <header className="relative z-10 max-w-[1200px] w-full mx-auto px-6 md:px-8 h-[84px] flex items-center justify-between">
        <Logo className="text-white" height={26} />
        <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-white/55 border border-white/12 rounded-full px-3.5 py-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--crea-red)] animate-pulse" />
          Binnenkort
        </span>
      </header>

      {/* Main */}
      <main className="relative z-10 flex-1 flex items-center">
        <div className="max-w-[1200px] w-full mx-auto px-6 md:px-8 py-10 md:py-14">
          <div className="max-w-[720px]">
            <div className="fade-up inline-flex items-center gap-2 text-[12px] font-semibold tracking-[0.14em] uppercase text-white/55">
              <Sparkles className="h-3.5 w-3.5 text-[var(--crea-red)]" />
              Precisiegravures in hout en metaal
            </div>

            <h1
              className="fade-up font-display font-extrabold text-white leading-[1.02] tracking-tight mt-6 text-[46px] sm:text-[64px] lg:text-[76px]"
              style={{ animationDelay: '0.1s' }}
            >
              Er komt iets{' '}
              <span className="text-[var(--crea-red)]">moois</span> aan.
            </h1>

            <p
              className="fade-up mt-6 text-[17px] leading-relaxed text-white/60 max-w-[520px]"
              style={{ animationDelay: '0.2s' }}
            >
              We zetten de laatste puntjes op de i. Onze nieuwe collectie
              gepersonaliseerde lasergravures — gemaakt met industri&euml;le
              precisie — staat bijna online.
            </p>

            {/* Signup */}
            <div
              className="fade-up mt-11 max-w-[500px]"
              style={{ animationDelay: '0.3s' }}
            >
              {done ? (
                <div className="flex items-center gap-3 h-[56px] px-5 rounded-full bg-white/[0.05] border border-white/10 text-white/80">
                  <span className="h-7 w-7 rounded-full bg-[var(--crea-red)] flex items-center justify-center">
                    <Check className="h-4 w-4 text-white" />
                  </span>
                  Je staat op de lijst — bedankt!
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  className="flex flex-col sm:flex-row gap-3"
                >
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="jouw@email.nl"
                    className="flex-1 h-[56px] px-5 rounded-full bg-white/[0.05] border border-white/12 text-white placeholder-white/35 outline-none focus:border-[var(--crea-red)] focus:bg-white/[0.07] transition-colors"
                  />
                  <button
                    type="submit"
                    className="btn-red inline-flex items-center justify-center gap-2 h-[56px] px-7 rounded-full font-medium text-[15px] whitespace-nowrap"
                  >
                    Hou mij op de hoogte
                    <ArrowRight className="h-4 w-4" />
                  </button>
                </form>
              )}
              <p className="mt-3 text-[13px] text-white/35">
                Geen spam. Alleen een seintje bij de lancering.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 max-w-[1200px] w-full mx-auto px-6 md:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-5 border-t border-white/[0.07]">
        <p className="text-[13px] text-white/40 order-2 sm:order-1">
          &copy; 2026 CreaLabs. Alle rechten voorbehouden.
        </p>
        <div className="flex gap-3 order-1 sm:order-2">
          <SocialButton label="Instagram">
            <Instagram className="h-[18px] w-[18px]" strokeWidth={1.8} />
          </SocialButton>
          <SocialButton label="Facebook">
            <Facebook className="h-[18px] w-[18px]" strokeWidth={1.8} />
          </SocialButton>
          <SocialButton label="E-mail">
            <Mail className="h-[18px] w-[18px]" strokeWidth={1.8} />
          </SocialButton>
        </div>
      </footer>
    </div>
  );
}
